module.exports = __webpack_public_path__ + "static/media/stationary-sitting.d793b383.svg";